import { Switch } from "ant-design-vue"
const { ...other } = Switch;
const YwSwitch = {
  ...other,
  name: "YwSwitch",
}

YwSwitch.install = function (Vue) { 
  Vue.component(YwSwitch.name, Switch);
}

export default YwSwitch